import React, { Component } from "react";
import ReactHighcharts from "react-highcharts";
import PropTypes from "prop-types";
import styled from "styled-components";
import moment from "moment";
require("highcharts/modules/wordcloud")(ReactHighcharts.Highcharts);

ReactHighcharts.Highcharts.setOptions({ global: { useUTC: false } });
const clone = data => {
  return JSON.parse(JSON.stringify(data));
};
const Wrapper = styled.div`
  height: ${props => props.height}px;
`;

const DefaultConfig = {
  title: {
    text: "",
    align: "left",
    margin: 50
  },
  chart: {
    height: 510
  },
  credits: {
    enabled: false
  },
  plotOptions: {
    series: {
      marker: {
        enabled: true,
        symbol: "circle"
      }
    }
  },
  yAxis: {
    title: {
      enabled: false
    }
  },
  legend: {
    symbolWidth: 0,
    symbolPadding: 10
  },
  series: []
};

export default class Chart extends Component {
  static propTypes = {
    chartType: PropTypes.oneOf(["line", "pie", "wordcloud"]),
    series: PropTypes.array,
    title: PropTypes.string,
    height: PropTypes.number
  };

  static defaultProps = {
    chartType: null,
    series: [],
    height: 500
  };

  prepareConfig(chartType, title, height, series) {
    let config = clone(DefaultConfig);
    let normalizedSeries = [];
    if (chartType === "line") {
      config.xAxis = { type: "datetime", gridLineWidth: 1 };
      normalizedSeries = series.map(item => {
        return {
          ...item,
          data: item.data.map(point => [
            moment(point.name).valueOf(),
            point.value
          ])
        };
      });
    } else if (chartType === "pie") {
      normalizedSeries = [
        {
          type: "pie",
          allowPointSelect: true,
          keys: ["name", "y", "selected", "sliced"],
          data: series.map((item, index) => [
            item.name,
            item.value,
            index === 0,
            index === 0
          ]),
          showInLegend: true
        }
      ];
    } else if (chartType === "wordcloud") {
      ReactHighcharts.Highcharts.setOptions({
        colors: [
          "#45C0E7",
          "#385E83",
          "#3493D0",
          "#72A8D5",
          "#817D7C",
          "#BAB7B7"
        ]
      });
      normalizedSeries = [
        {
          type: "wordcloud",
          data: series.map(item => {
            return { name: item.name, weight: item.value };
          })
        }
      ];
      // series.map(item=>console.log(item));

      config.chart.width = height;
    }

    config.title.text = title;
    config.series = normalizedSeries;
    config.chart.height = height;
    return config;
  }

  render() {
    const { chartType, series, title, height } = this.props;
    const config = this.prepareConfig(chartType, title, height, series);

    return (
      <Wrapper height={height}>
        <ReactHighcharts config={config} />
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/module-analytics/components/Chart.js